import React from "react";
import { useParams } from "react-router-dom";

import {
    Typography,
    Grid,
    Chip,
} from "@mui/material";

import DetailsView from "../Common/Views/DetailsView";

function EmployeeDataLayout({ data }) {
    const getStatusColor = (status) => {
        switch (status) {
            case 'ACTIVE':
                return 'success';
            case 'INACTIVE':
                return 'warning';
            case 'TERMINATED':
                return 'error';
            default:
                return 'default';
        }
    };

    const getStatusLabel = (status) => {
        const statusLabels = {
            'ACTIVE': 'Active',
            'INACTIVE': 'Inactive',
            'TERMINATED': 'Terminated'
        };
        return statusLabels[status] || status;
    };

    return (
        <>
            <Grid container spacing={2}>
                <Grid item xs={12} sm={6} lg={4}>
                    <Typography variant="subtitle2" color="text.secondary">
                        Name
                    </Typography>
                    <Typography variant="body2">{data.name || "-"}</Typography>
                </Grid>

                <Grid item xs={12} sm={6} lg={4}>
                    <Typography variant="subtitle2" color="text.secondary">
                        Phone Number
                    </Typography>
                    <Typography variant="body2">{data.phoneNumber || "-"}</Typography>
                </Grid>

                <Grid item xs={12} sm={6} lg={4}>
                    <Typography variant="subtitle2" color="text.secondary">
                        Status
                    </Typography>
                    <Chip 
                        label={getStatusLabel(data.status)} 
                        color={getStatusColor(data.status)}
                        size="small"
                    />
                </Grid>
            </Grid>
        </>
    );
}


export default function EmployeeDetails() {
    const { id } = useParams();

    return (
        <>
            <DetailsView
                title="Employee details"
                subtitleAttribute="name"
                apiPath={`/tenants/employees/${id}`}
                editPath={`/employees/${id}/edit`}
                onDelete={(data) => {
                    console.log("Delete action for", data);
                    // you can plug delete API call here
                }}
            >
                {({ data }) => <EmployeeDataLayout data={data} />}
            </DetailsView>
        </>
    )
};
